<template>
  <div class="skin-card">
    <div class="skin-image">
      <Thumb
        :font-size="10"
        :height="10"
        :item="item"
        :loading="imgLazy ? 'lazy' : 'eager'"
        :size="10"
        :src="getImageFromWaxpeer(`${getItemNameWithCategory(item.market_hash_name)}-${item.exterior}`)"
      />
    </div>
    <span
      :style="{ background: item.rarity_color }"
      class="rarity-dot"
    />

    <div class="skin-info">
      <span
        v-if="item.collection"
        v-tooltip="item.collection >= 27 ? item.collection : ''"
        class="skin-collection ell"
      >
        {{ item.collection }}
      </span>

      <span
        :class="{
          'is-stattrak': item.is_stattrak,
        }"
        class="skin-name ell"
      >
        <!--          {{getWeaponOnly(item.localed_name)  }} -->
        {{ getItemNameWithCategory(item.localed_name) }}
      </span>

      <!--      <p -->
      <!--          v-if="item.localed_skin || getMarketName(item.localed_name)" -->
      <!--          class="skin-name ell" -->
      <!--      > -->
      <!--        {{ item.localed_skin || getMarketName(item.localed_name) }} -->
      <!--      </p> -->

      <div
        v-if="item.min_price || item.max_price"
        class="skin-prices"
      >
        <UiPrice :price="item.min_price" />
        <template v-if="item.max_price">
          -
          <UiPrice :price="item.max_price" />
        </template>
      </div>

      <FloatBar
        :max="item.item_max_float || 0"
        :min="item.item_min_float || 0"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AdvancedSearchBody } from '~/graphql/generated/schema-types';
import Thumb from '~/components/Pages/Item/Components/Children/Thumb.vue';
import FloatBar from '~/components/ui/FloatBar.vue';
import { getImageFromWaxpeer } from '~/utils/get-image-url';
import { getItemNameWithCategory } from '~/utils/name-utils';

defineProps<{
  item: AdvancedSearchBody
  imgLazy: boolean
}>();
</script>

<style lang="scss" scoped>
@use 'sass:color';

.skin-card {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: var(--surfaces-variable-container);
  position: relative;
  transition: background-color 0.5s ease, transform .2s ease;
  cursor: pointer;
  padding: 16px 12px;
  gap: 4px;

  &:deep(.thumb) {
    padding: 10px;

    img {
      transition: 0.5s scale;
      height: 120px;
      width: 120px;
    }
  }

  &:hover,
  &:focus {
    outline: none;
    background: color-mix(in srgb, var(--surfaces-low-container) 98%, white);

    :deep(.thumb) img {
      scale: 1.1;
    }
  }

  &:active {
    transform: translateY(5px);
  }

  .skin-info {
    margin: auto 0 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;

    .skin-collection {
      color: var(--accent-on-surface);
      text-align: center;
      font-kerning: none;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }

    //.skin-brand {
    //  font-weight: 400;
    //  font-size: 1.4rem;
    //  line-height: 1.9rem;
    //  color: var(--surfaces-on-surface-variable);
    //
    //}

    .skin-name {
      color: var(--surfaces-on-surface);
      text-align: center;
      font-kerning: none;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
      &.is-stattrak {
        color: var(--stattrak);
      }
    }
  }

  .skin-prices {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    text-align: center;
    color: var(--surfaces-on-surface-variable);
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;

    :deep(.price) {
      color: var(--surfaces-on-surface-variable);
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
    }
  }

  .skin-offers {
    position: absolute;
    top: calc(100%);
    left: 0;
    right: 0;
    z-index: 5;
    transition: all ease 0.5s;
    opacity: 0;
    background: var(--accent-secondary);
    border-radius: 0 0 12px 12px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    padding: 3px;
  }

  .rarity-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: absolute;
    top: 12px;
    left: 12px;
  }
}
</style>
